import { USER_TYPE_AGENT } from "../constants/common";
// Non-prod environments alias tenant subdomains with a `-staging` suffix
// (e.g. lar-staging) to avoid colliding with the prod hostname on the same
// registrar. Strip it so tenant resolution matches the base slug (`lar`)
// used by both the tenant config filenames and the API's TENANT_SLUG_TO_MLS_ID.
export const getTenantSubdomain = () => {
  if (typeof window === "undefined") return "";
  return window.location.hostname
    .toLowerCase()
    .split(".")[0]
    .replace(/-staging$/, "");
};

// BLC starts "Syndicate to the public" unchecked; every other tenant keeps it on.
const TENANTS_SYNDICATION_OFF_BY_DEFAULT = ["blc"];
export const isSyndicationCheckedByDefault = () =>
  !TENANTS_SYNDICATION_OFF_BY_DEFAULT.includes(getTenantSubdomain());

export const isMlsRestrictedTenant = (tenant) => {
  if (!tenant) return false;
  return Boolean(
    tenant.mlsRestricted ||
      tenant.auth?.requiresLogin ||
      tenant.auth?.saml?.enabled,
  );
};

// Cache for non-React callers; AppConfigProvider primes it at boot.
// `undefined` = unprimed (distinct from `null` = primed, non-BLS).
let cachedTenant = undefined;
export const setCachedTenant = (tenant) => {
  cachedTenant = tenant;
};
export const getCachedTenant = () => cachedTenant;
export const isTenantPrimed = () => cachedTenant !== undefined;
export const isCurrentTenantMlsRestricted = () =>
  isMlsRestrictedTenant(cachedTenant);

// Both halves matter: the Gitcha feed is public, so "not an agent" alone would
// hand owner wording to anyone signed out on a BLS domain. Tests tenant id
// rather than isMlsRestrictedTenant because `bls` and `stellar` are BLS but
// carry no mlsRestricted flag. An unprimed cache falls back to agent wording.
export const isGitchaOwnerView = (userType) =>
  userType !== USER_TYPE_AGENT && cachedTenant?.id === "default";
